module.exports = __webpack_public_path__ + "static/img/238_TO8_2000.1dbc91e.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/238_TO8_2000.jpg
// module id = auKP
// module chunks = 0